import {useTranslationContext} from 'platform/components';

import type {TestIdProps} from 'shared/web';

import {PRESET_DROPDOWN_STYLES} from '../../constants/PRESET_DROPDOWN_STYLES';
import {PRESET_TAB_STYLES} from '../../constants/PRESET_TAB_STYLES';
import {PresetActionsIcon} from '../PresetActionsIcon/PresetActionsIcon';

type PresetActionsButtonProps = TestIdProps & {
  variant: 'tab' | 'option';
  isDisabled?: boolean;
  isExpanded: boolean;
};

// IconButton cannot inherit preset colors or provide the smaller circular menu variant.
// Keep those Stock Report treatments here so every preset actions trigger shares one control.
export function PresetActionsButton(props: PresetActionsButtonProps) {
  const t = useTranslationContext();

  return (
    <button
      type="button"
      aria-label={t('general.labels.more')}
      aria-haspopup="menu"
      aria-expanded={props.isExpanded}
      disabled={props.isDisabled}
      className={
        props.variant === 'option'
          ? `${PRESET_DROPDOWN_STYLES.actionButton} ${PRESET_DROPDOWN_STYLES.unpinned}`
          : PRESET_TAB_STYLES.actionButton
      }
      data-testid={props['data-testid']}
    >
      <PresetActionsIcon />
    </button>
  );
}
